import React, { useEffect, useState } from "react";
import { Select, Space } from "antd";

export const DropdownJobtype = ({ jobTypeList, setJobTypeList, jobTypeDetail, onSelectChange }) => {
  const [size, setSize] = useState("large");
  const [selectValue, setSelectValue] = useState('');
  const [options, setOptions] = useState([]);
  const optionList = [
      {
        value: ``,
        label: `Please choose`,
      },
      {
        value: "Asset Verification",
        label: "Asset Verification"
      },
      {
        value: "Backfill Order",
        label: "Backfill Order"
      },
      {
        value: "Check-In",
        label: "Check-In"
      },  
      {
        value: "Content Update (SD Card)",
        label: "Content Update (SD Card)"
      },
      {
        value: "Content Update (Wi-Fi)",
        label: "Content Update (Wi-Fi)"
      },
      {
        value: "De-install",
        label: "De-install"
      },
      {
        value: "De-install (to be moved)",
        label: "De-install (to be moved)"
      },
      {
        value: "De-install (to be re-installed)",
        label: "De-install (to be re-installed)"
      },
      {
        value: "Demo Unit",
        label: "Demo Unit"
      },
      {
        value: "Follow Up Install",
        label: "Follow Up Install"
      },
      {
        value: "Misc. Service",
        label: "Misc. Service"
      },
      {
        value: "Multiple Services",
        label: "Multiple Services"
      },
      {
        value: "New Order",
        label: "New Order"
      },
      {
        value: "Parts Only",
        label: "Parts Only"
      },
      {
        value: "Re-install (at new location)",
        label: "Re-install (at new location)"
      },
      {
        value: "Reconnect & App Update",
        label: "Reconnect & App Update"
      },
      {
        value: "Replacement",
        label: "Replacement"
      },
      {
        value: "Reship",
        label: "Reship"
      },
      {
        value: "Retrieval/Pick Up",
        label: "Retrieval/Pick Up"
      },
      {
        value: "Unit Exchange",
        label: "Unit Exchange"
      },
      {
        value: "Upsell Order",
        label: "Upsell Order"
      } 
    ];


  const handleChange = (value) => {
    onSelectChange(value);
  };

  useEffect(() => {
    
    if (jobTypeDetail && jobTypeDetail !== "") {

      var updatedJobTypeList = [''];
      if(jobTypeDetail) {
        updatedJobTypeList  = jobTypeList.filter(jobType => jobType !== jobTypeDetail);

      }

    const filteredOptions = optionList.filter(option => !updatedJobTypeList.includes(option.value));
    if(filteredOptions) {

      setOptions(filteredOptions);
    }
      handleChange(jobTypeDetail);
      setSelectValue(jobTypeDetail);
    }

    if(jobTypeDetail === '' || jobTypeDetail === undefined) {
      setSelectValue('');
    }
    
  }, [jobTypeDetail]);

  useEffect(() => {
    const filteredOptions = optionList.filter(option => !jobTypeList.includes(option.value));
    if(filteredOptions) {
      setOptions(filteredOptions);
    }

  }, [jobTypeList]);

  return (
    <>
      <Space
        direction="vertical"
        style={{
          width: "100%",
        }}
      >
        <Select
          size={size}
          defaultValue={options[0]}
          value={selectValue}
          onChange={handleChange}
          style={{
            width: "100%",
          }}
          options={options}
        />
      </Space>
    </>
  );
};

export const DropdownIf = ({ifDetail, DoValueDetail, ifDoQuestions, uuid, onSelectChange }) => {
  const [size, setSize] = useState("large");
  const [selectValue, setSelectValue] = useState('');
  const [options, setOptions] = useState([{ value: '', label: 'Please choose' }]);
  
  const getQuestion = () => {
    const uniqueValues = new Set();
    const newOptions = []; 
    const filteredQuestions = ifDoQuestions;
    setOptions([{ value: '', label: 'Please choose' }]);
    filteredQuestions.forEach(question => {
      if (!uniqueValues.has(question.value) && DoValueDetail !== question.value) {
        uniqueValues.add(question.value);

        newOptions.push({
          value: question.value,
          label: question.value,
        });
      }
    });
    setOptions(prevOptions => [...prevOptions, ...newOptions]);
  };
  
  

  const handleChange = (value) => {
    onSelectChange(value);
  };

  useEffect(() => {
    if (ifDetail && ifDetail !== "") {
      handleChange(ifDetail);
      setSelectValue(ifDetail);
    }
  }, [ifDetail]);

  return (
    <>
      <Space
        direction="vertical"
        style={{
          width: "100%",
        }}
      >
        <Select
          size={size}
          defaultValue={options[0]}
          value={selectValue}
          onChange={handleChange}
          onFocus={getQuestion}
          style={{
            width: "100%",
          }}
          options={options}
        />
      </Space>
    </>
  );
};

// ---------------------State dropdown------------------

export const DropdownState = ({stateDetail, onSelectChange}) => {
  const [size, setSize] = useState("large");
  const [selectValue, setSelectValue] = useState('');
  const options = [
    {
    value: ``,
    label: `Please choose`,
    },
    {
    value: `Is Equal To`,
    label: `Is Equal To`,
    },
    {
    value: `Is Not Equal To`,
    label: `Is Not Equal To`,
    },
    {
      value: `Is Empty`,
      label: `Is Empty`,
    },
    {
      value: `Is Filled`,
      label: `Is Filled`,
    },
  ];


  const handleChange = (value) => {
    // console.log(`Selected: ${value}`);
    onSelectChange(value);
  };

  useEffect(() => {
    if (stateDetail && stateDetail !== "") { 
      handleChange(stateDetail);
      setSelectValue(stateDetail);
    }
  }, [stateDetail]);


  return (
    <>
      <Space
        direction="vertical"
        style={{
          width: "100%",
        }}
      >
        <Select
          size={size}
          defaultValue={options[0]}
          value={selectValue}
          onChange={handleChange}
          style={{
            width: "100%",
          }}
          options={options}
        />
      </Space>
    </>
  );
};

//---------------Dropdown Value-----------------
export const DropdownValue = ({valueDetail, onSelectChange}) => {
  const [size, setSize] = useState("large");
  const [selectValue, setSelectValue] = useState('');
  const options = [
    {
      value: ``,
      label: `Please choose`,
    },
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
  ];

  const handleChange = (value) => {
    onSelectChange(value);
  };

  useEffect(() => {
    if (valueDetail && valueDetail !== "") { 
      handleChange(valueDetail);
      setSelectValue(valueDetail);
    }
  }, [valueDetail]);

  return (
    <>
      <Space
        direction="vertical"
        style={{
          width: "100%",
        }}
      >
        <Select
          size={size}
          defaultValue={options[0]}
          value={selectValue}
          onChange={handleChange}
          style={{
            width: "100%",
          }}
          options={options}
        />
      </Space>
    </>
  );
};

//---------------Dropdown Value-----------------
export const DropdownDo = ({doDetail, ifValueDetail, ifDoQuestions, uuid, onSelectChange}) => {
  const [size, setSize] = useState("large");
  const [selectValue, setSelectValue] = useState('');
  const [options, setOptions] = useState([{ value: '', label: 'Please choose' }]);
  const getQuestion = () => {
    const uniqueValues = new Set();
    const newOptions = []; 
    setOptions([{ value: '', label: 'Please choose' }]);
    const filteredQuestions = ifDoQuestions;
  
    filteredQuestions.forEach(question => {
      if (!uniqueValues.has(question.value) && ifValueDetail !== question.value) {
        uniqueValues.add(question.value);

        newOptions.push({
          value: question.value,
          label: question.value,
        });
      }
    });
    setOptions(prevOptions => [...prevOptions, ...newOptions]);
  };

  const handleChange = (value) => {
    onSelectChange(value);
  };

  useEffect(() => {
    if (doDetail && doDetail !== "") { 
      handleChange(doDetail);
      setSelectValue(doDetail);
    }
  }, [doDetail]);
  return (
    <>
      <Space
        direction="vertical"
        style={{
          width: "100%",
        }}
      >
        <Select
          size={size}
          defaultValue={options[0]}
          value={selectValue}
          onChange={handleChange}
          onFocus={getQuestion}
          style={{
            width: "100%",
          }}
          options={options}
        />
      </Space>
    </>
  );
};
